import { IOptions, IObj } from '../../constants/types/common.types'
import { STATIC_URL } from '../data'
import { specialityTexts, CARDS_ON_PAGE, FilterTypeName, Key, pageKeys } from './search-data'
import { formatSelect } from '../../utils/search/formatParams'
import { IInitParams } from '../types/search.types'
import { IEventCard } from 'constants/types/card.types'
import { BASE_URL } from '../url'

/* Для единообразия с другими фильтрами */
const Option = {
  lectors: 'Лекторы',
}

const InitParams: IObj<IInitParams> = {
  [Option.lectors]: {
    [Key.TEXT]: '',
    [Key.SPECIALITIES]: [],
    [Key.PAGE]: '1',
  },
}

const InitValues = {
  params: {
    [Option.lectors]: InitParams[Option.lectors],
  },
  pages: {
    [Option.lectors]: { [pageKeys.TOTAL]: 0, [pageKeys.CURRENT]: 0 },
  },
  cards: {
    [Option.lectors]: [] as IEventCard[],
  },
  allCount: {
    [Option.lectors]: 0,
  },
}

const generateConfig = (specialities: IOptions[]) => ({
  [Option.lectors]: {
    input: {
      placeholder: 'Поиск по имени...',
      key: Key.TEXT,
      sideIconPath: `${STATIC_URL}/filters/search-icon.svg`,
    },
    main: [
      {
        inputType: FilterTypeName.SELECT,
        themes: specialities,
        mobileSwitchBtnText: specialityTexts,
        title: 'Специальность',
        placeholder: 'Поиск по специальностям...',
        key: Key.SPECIALITIES,
        formatter: formatSelect,
      },
    ],
  },
})

const LectorSearchURL = {
  LECTURE: `${BASE_URL.LECTUR}?count=true`,
  LECTURE_SINGLE: BASE_URL.LECTUR,
  LECTURE_ARTICLES: `${BASE_URL.ARTICLE}?ArticleTypeId=1&limit=${CARDS_ON_PAGE}&count=true`,
  LECTURE_VIDEO: `${BASE_URL.ARTICLE}?ArticleTypeId=2&limit=${CARDS_ON_PAGE}&count=true`,
  LECTURE_WEBINARS: `${BASE_URL.WEBINAR}?limit=${CARDS_ON_PAGE}&count=true`,
  LECTURE_MATERIALS: `${BASE_URL.LECTUR}/materials?count=true`,
}

export { InitValues, generateConfig, Key, LectorSearchURL, InitParams, Option }
